import eventBus from '@/libs/event/event-bus'
import { liveInfoEventHandler } from './global-liveinfo'

window.liveInfoEventBuffer = []

window.liveInfoCall = (funcName, p) => {
  if (!p) {
    eventBus.$emit(liveInfoEventHandler, { funcName })
  } else {
    eventBus.$emit(liveInfoEventHandler, { funcName, p: JSON.parse(p) })
  }

  // 버퍼에 저장 (이벤트 유실 대비, funcName당 최신 1건만 유지)
  const payload = !p
    ? { funcName }
    : { funcName, p: JSON.parse(p) }
  const idx = window.liveInfoEventBuffer.findIndex(item => item.funcName === funcName)
  if (idx > -1) {
    window.liveInfoEventBuffer[idx] = payload
  } else {
    window.liveInfoEventBuffer.push(payload)
  }
}
